import React from "react";
import Home from "../pages/Home/Home.jsx";
import Privacy from "../pages/privacy/Privacy.jsx";
import Path from "./Constant/RoutePath.jsx";
export default function PAGES() {
  return {
    PUBLIC_PAGES: [
      { path: Path.HOME, element: <Home /> },
      { path: Path.PRIVACY, element: <Privacy /> },
    ],
    // PRIVATE_PAGES: [
    //     { path: Path.FEATURE, element: <Feature /> },
    //   ]
  };
}
